<template>
  <b-table
    :data="uploader.files"
    :paginated="tablaFotos.isPaginated"
    :hoverable="tablaFotos.isHoverable"
    :per-page="tablaFotos.perPage"
    :current-page.sync="tablaFotos.currentPage"
    :pagination-simple="tablaFotos.isPaginationSimple"
    :narrowed="tablaFotos.isNarrowed"
    :mobile-cards="tablaFotos.hasMobileCards"
    id="upload-table"
  >
    <template slot-scope="props">
      <b-table-column
        field="nombre"
        label="Nombre"
        width="100"
      >{{ (window.width > 500) ? props.row.name : '..' + props.row.name.substring(props.row.name.length - 15 ) }}</b-table-column>

      <b-table-column field="estado" label="Estado" width="4">
        <span v-if="props.row.status === 5" class="tag is-success">Subido</span>
        <span v-if="props.row.status === 4" class="tag is-danger">Error</span>
        <span v-if="props.row.status === 2" class="tag is-info">Subiendo</span>
        <span v-if="props.row.status === 1" class="tag is-primary">Preparado</span>
      </b-table-column>

      <b-table-column field="tamano" label="Tamaño" width="4">{{ formatFileSize(props.row.size) }}</b-table-column>

      <b-table-column field="porcentaje" label="% Subido" width="5">{{ props.row.percent }}%</b-table-column>

      <b-table-column label="Acciones" centered width="2">
        <b-button
          type="is-danger"
          size="is-small"
          @click="$emit('eliminar-foto', { id: props.row.id, nombre: props.row.name })"
          icon-left="trash-can-outline"
        >Eliminar</b-button>
      </b-table-column>
    </template>
  </b-table>
</template>

<style>
#boxFotos {
  padding: 0.5rem;
}

@media only screen and (max-width: 768px) {
  #upload-table {
    max-height: 200px;
    overflow-y: auto;
  }
}
</style>

<script>
export default {
  name: 'BoxFotos',
  data () {
    return {
      window: {
        width: 0,
        height: 0
      }
    }
  },
  props: {
    uploader: {
      type: Object,
      required: true
    },
    tablaFotos: {
      type: Object,
      required: true
    }
  },
  methods: {
    // Formate un size en bytes usando la funcion de plupload
    formatFileSize (size) {
      return this.$plupload.formatSize(size)
    },
    // Se encarga de manejar los resize de la pantalla y actualiza variables de data
    handleResize () {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
    }
  },
  created () {
    // Agrega event listener para el resize
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
